<div class="container" *ngIf="!showquizresume">

<form [formGroup]="jeuForm" id="formjeu" (ngSubmit)="submit()" *ngIf="!showcreatejeu">
    <div class="row">
      <div class="col">
        <div class="row d-flex justify-content-center">
          <select formControlName="categorie" (change)="changeCategorie($event)">
            <option [ngValue]="null" disabled>Select categorie</option>
            <option *ngFor="let c of categories" value="{{c.id}}" [ngValue]="c.id">{{c.nom}}</option>
            <option [ngValue]="0" > Autre </option>
          </select>  
        </div>
        <div class="row mt-2 d-flex justify-content-center">
          <input formControlName="inputcat" *ngIf="actualcatid == 0" placeholder="Nom de votre categorie" >
        </div>
      </div>
      <div class="col">
        <div class="row d-flex justify-content-center">
          <select formControlName="souscategorie" (change)="changeSousCategorie($event)">
            <option [ngValue]="null" disabled>Select categorie</option>
            <option *ngFor="let s of sousCategories" [ngValue]="s.id">{{s.nom}}</option>
            <option [ngValue]="0" > Autre </option>
          </select>
        </div>
        <div class="row mt-2 d-flex justify-content-center">
          <input formControlName="inputsouscat" *ngIf="actualcatid == 0 || actualsouscatid == 0" placeholder="Nom de votre sous categorie"  >
        </div>
      </div>
      <div class="col">
        <div class="row  d-flex justify-content-center">
        <select formControlName="typejeu">
          <option [ngValue]="null" disabled>Select type de jeu</option>
          <option *ngFor="let j of typeJeu" [ngValue]="j.id">{{j.nom}}</option>
        </select>
      </div>
      </div>      
    </div>
    <div class="row mx-auto">
        <div class="col d-flex justify-content-center mt-5">
          <button type="submit" [disabled]="!jeuForm.valid">Créer une question</button>
        </div>
    </div>
    </form>
    <div *ngIf="showcreatejeu">
      <app-create-jeu-resume-cat  [categorie]="categorieSelected" [sousCategorie]="sousCategorieSelected"[typeJeu]="typeJeuSelected"></app-create-jeu-resume-cat>
      <div class="row">
        <p>Nombre de question : {{ listQuestion.length }}</p>
      </div>
    </div>
    <div class="ligne"></div>
    <p>
      <app-create-jeu-quatre-choix (quizEvent)="finaliserQuiz($event)" (jeuAlbumEvent)="ajouterQuestion($event)" *ngIf="showcreatejeu == 1" ></app-create-jeu-quatre-choix>
      <app-create-jeu-quatre-img *ngIf="showcreatejeu == 2"></app-create-jeu-quatre-img>
    </p>
  </div>
<div class="container" *ngIf="showquizresume">
  <app-create-jeu-resume-cat [categorie]="categorieSelected" [sousCategorie]="sousCategorieSelected"[typeJeu]="typeJeuSelected"></app-create-jeu-resume-cat>
  <div class="row">
    <p>Nombre de question : {{ listQuestion.length }}</p>
  </div>
    <div class="ligne"></div>
    <div class="container">
      <form [formGroup]="quizForm" (ngSubmit)="submitQuiz()">
        <div class="row d-flex justify-content-around mt-5">
          <label>Nom du quiz</label>
          <input type="text" placeholder="Nom de votre quiz" formControlName="nom">
        </div>
        <div class="row d-flex justify-content-center mt-5">
          <textarea class="form-control" placeholder="Entrer une description de votre quiz" formControlName="description"></textarea>
        </div>
        <div class="col d-flex justify-content-center mt-5">
          <button type="submit" [disabled]="!quizForm.valid">Valider</button>
        </div>
      </form>
    </div>
    <div>
      <app-resume-question *ngFor="let question of listQuestion" [question]="question"></app-resume-question>
    </div>
</div>